import React, {Component} from "react";
import {createRoot} from 'react-dom/client';
import Header from "../components/Header/Header";
import "../../sass/_document.scss";
import Grid from "../components/Grid/Grid";
import Footer from "../components/Footer/Footer";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";
import TopAmbassadors from "../components/TopAmbassadors/TopAmbassadors";
import Common from "../utils/common";

const newChannelApiUrl = Common.getContentApiUrl();
console.log("home")
class Home extends Component {
    render() { 
        const channelApiUrl = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getLatestVideosChannelId()}/contents`;
        return <div data-testid="homepage" className={"document-body " + theme.hub_wrapper_css_class}>
            {ConfigurationHelper.enableHeaderFooter() && <Header/>}
            <Breadcrumbs keepOnMobile/>
            <TopAmbassadors/>
            <div className={"container"}>
                <div className={"row"}>
                    <h2 className={"col-12 text-center tvp-latest-post-title"}>RECENTLY POSTED</h2>
                </div>
            </div>
            <Grid gridTitle={" "} baseApiUrl={newChannelApiUrl}/>
            {ConfigurationHelper.enableHeaderFooter() && <Footer/>}
        </div>;
    }
}

export default Home;

const targetEl = document.getElementById("app-container");

if (targetEl){
    const root = createRoot(targetEl)
    root.render(<Home/>);
}